<script setup lang="ts">
const { error = "" } = defineProps<{
  error?: string;
}>();
</script>

<template>
  <div v-if="error" class="error-message">
    <BaseIcon class="icon" name="error"></BaseIcon>
    <div class="message">{{ error }}</div>
  </div>
</template>

<style lang="scss" scoped>
.error-message {
  display: flex;
  align-items: flex-start;
  font-weight: bold;
  font-size: 0.8rem;
  text-align: left;
}

.icon {
  flex-shrink: 0;
  margin-right: 0.2em;
}
</style>
